import { showRefreshButtonState, FunctionMap } from '../../types';
import { SHOW_REFRESH_BUTTON } from '../constants';
import { createReducer } from './Utils';

const showRefreshButtonDefaultState: showRefreshButtonState = {
  showRefreshButton: false,
};

function showRefreshButtonButton(state: showRefreshButtonState) {
  return Object.assign({}, state, {
    showRefreshButton: !state.showRefreshButton,
  });
}

const functionMap: FunctionMap = {
  [SHOW_REFRESH_BUTTON]: showRefreshButtonButton,
};

export default createReducer(functionMap, showRefreshButtonDefaultState);
